import React from 'react'
import { Grid } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { insertAsteriskBetweenCharacters } from '../ProductsConfiguration'
import LiquidCheckbox from '@src/components/LiquidCheckbox'
import useFormikHelper from '../useFormikHelper'
import { ModificationValues } from '../enum'

interface AsteriskProps {}

const Asterisk: React.FC<AsteriskProps> = () => {
  const formik = useFormikHelper()

  const onInsertAsteriskChange = async (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    let sequenceString: string = ''
    if (formik.selectedOligoValues.sequence && e.target.checked) {
      sequenceString = insertAsteriskBetweenCharacters(
        formik.selectedOligoValues.sequence,
        !!formik.selectedOligoValues.fiveMod &&
          formik.selectedOligoValues?.fiveMod !== ModificationValues.None,
        !!formik.selectedOligoValues.threeMod &&
          formik.selectedOligoValues?.threeMod !== ModificationValues.None
      )
      formik.setFieldTouched('sequence', true, false)
      formik.setOligoFieldValue('insertAsterisk', e.target.checked, false)
      formik.setOligoFieldValue('sequence', sequenceString, false)
    } else {
      formik.setOligoFieldValue('insertAsterisk', e.target.checked, false)
    }
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <FormattedMessage
          id="CONF_SEQUENCE_MESSAGE"
          defaultMessage="Insert an asterisk '*' between bases that are to be phosphorothioated."
        />
      </Grid>
      <Grid item>
        <LiquidCheckbox
          checked={!!formik.selectedOligoValues.insertAsterisk}
          onChange={onInsertAsteriskChange}
          label={
            <FormattedMessage
              id="FULL_OLIGO_ASTERISK_INSERT_MESSAGE"
              defaultMessage="Full S-oligo backbone: Automatically insert asterisk between all bases."
            />
          }
        />
      </Grid>
    </Grid>
  )
}

export default Asterisk
